import request from '@/utils/request'

export function getSettleStatus() {
    return request.get('/app/settle/status', {}, { needRedirect: false, showError: false })
}
